const SET_FILTER_DATA = 'SET_FILTER_DATA'
const OPEN_FILTER_CAR = 'OPEN_FILTER_CAR'

const state = {
  selectFilterData:{},
  openFilterCar:{}
}


const mutations = {
  [SET_FILTER_DATA]: (state, value) => {
    state.selectFilterData= value
  },
  [OPEN_FILTER_CAR]: (state, value) => {
    state.openFilterCar= value
  },
}

const limit = {
  time: '',
  value: ''
}

const actions = {
  setFilterData({ commit },val){
    commit(SET_FILTER_DATA, val)
  },
  setOpenFilterCar({ commit },val){
    commit(OPEN_FILTER_CAR, val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
